/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export const black = {
    50: '#FFFFFF',
    100: '#F5F7FA',
    200: '#E0E0E0',
    300: '#C9C9C9',
    400: '#A6A6A6',
    500: '#8C8C8C',
    600: '#787878',
    700: '#636363',
    800: '#4F4F4F',
    900: '#3C3C3C',
    1000: '#262626',
};
